import script from "./ScribbleArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ScribbleArea.vue?vue&type=script&setup=true&lang=js"

import "./ScribbleArea.vue?vue&type=style&index=0&id=2268eb1c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2268eb1c"]])

export default __exports__